import { useMonitor } from '../use-monitor';

export function useMonitorAddIssueTemplatesFormSubmit() {
  return useMonitor('add-issue-templates-form-submit');
}
